import userServices from '@/services/user';

const state = {
  userRecord: {},
};

const getters = {
  getIsDone: (state) => (type) => {
    return state.userRecord[type] === true;
  },
};

const actions = {
  async getUserRecordIsDone({commit}, type) {
    let isForce = false;
    if (typeof type === 'object') {
      isForce = type.isForce;
      type = type.type;
    }
    const result = await userServices.getUserRecord(type, isForce);
    commit('setUserRecordIsDone', {[type]: result});
    return result;
  },
};

const mutations = {
  setUserRecordIsDone(state, value) {
    state.userRecord = {...state.userRecord, ...value};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
